import { render, staticRenderFns } from "./PaginationPages.vue?vue&type=template&id=5d2bbf31&"
import script from "./PaginationPages.vue?vue&type=script&lang=ts&"
export * from "./PaginationPages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports